import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Shared post creation function used by both Home.js and Profile.js
 * @param {Object} params - Post creation parameters
 * @param {string} params.caption - Post caption (min 10 characters)
 * @param {File|null} params.media - Optional image/media file
 * @returns {Promise<Object>} - API response data
 */
export const createPost = async ({ caption, media }) => {
  // Validate caption
  if (!caption || caption.trim().length < 10) {
    throw new Error('Caption must be at least 10 characters');
  }

  const formData = new FormData();
  formData.append('caption', caption.trim());
  
  if (media) {
    formData.append('media', media);
  }

  console.log('[createPost] Sending request to /api/social-posts...');
  console.log('[createPost] Caption:', caption.trim().substring(0, 50) + '...');
  console.log('[createPost] Has media:', !!media);

  const response = await axios.post(`${API_URL}/api/social-posts`, formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  console.log('[createPost] Response:', response.data);
  
  return response.data;
};
